import { useState } from "react";
import { HELP_FAQ } from "@/content/helpFaq";
import { cn } from "@/utils/cn";

type FaqAccordionProps = {
  defaultOpenCount?: number;
};

export function FaqAccordion({ defaultOpenCount = 0 }: FaqAccordionProps) {
  const [open, setOpen] = useState<Record<number, boolean>>(() => {
    const initial: Record<number, boolean> = {};
    for (let i = 0; i < Math.min(defaultOpenCount, HELP_FAQ.length); i++) {
      initial[i] = true;
    }
    return initial;
  });

  return (
    <div>
      {HELP_FAQ.map((item, index) => {
        const isOpen = open[index] ?? false;
        return (
          <div key={item.q} className={cn("pub-faq-item", isOpen && "is-open")}>
            <button
              type="button"
              className="pub-faq-q"
              aria-expanded={isOpen}
              onClick={() => setOpen((prev) => ({ ...prev, [index]: !isOpen }))}
            >
              <span>{item.q}</span>
              <span aria-hidden>{isOpen ? "−" : "+"}</span>
            </button>
            {isOpen ? <div className="pub-faq-a">{item.a}</div> : null}
          </div>
        );
      })}
    </div>
  );
}
